/**
 * @todo This should be a control.
 * @file
 */

/**
 * Primarily interacts with the following element:
 * `<asp:CheckBox ID="chkGridOption" runat="server" CssClass="gridOptionCheckbox" Text=" Show All Details" />`
 */
export function InitializeGridOptionCheckbox() {
    $("[id$='chkGridOption']").on("click", function (e) {
        var thisObj = $("[id$='chkGridOption']");
        ShowAllDetailCheckbox(thisObj);
    });

    $("td:first-child").on("click", function (e) {
        if (!$(this).is(":checked")) {
            $("[id$='chkGridOption']").prop("checked", false);
        }
    });

  $(".printIcon").on("click", openAll)
};

function openAll() {
    $("td:first-child").each(function () {
        if (!$(this).parent("tr").hasClass('parent')) {
            $(this).trigger("click");
        }
        
    });
    $("[id$='chkGridOption']").prop("checked", true);
}

function closeAll() {
    $("td:first-child").each(function () {
        if ($(this).parent("tr").hasClass('parent')) {
            $(this).trigger("click");
        }
    });
    $("[id$='chkGridOption']").prop("checked", false);

}

function ShowAllDetailCheckbox(thisObj) {
    if (thisObj.is(":checked")) {
        openAll();
    } else {
        closeAll();
    }
}
